import React, { createContext, useEffect } from 'react';
import { io } from 'socket.io-client';
import { useSelector } from 'react-redux';

const SocketContext = createContext();

// Use API URL if defined, otherwise default behavior (localhost/proxy)
const ENDPOINT = process.env.REACT_APP_API_URL || "http://localhost:5000";
const socket = io(ENDPOINT);

const ContextProvider = ({ children }) => {
    const { userInfo } = useSelector((state) => state.user);

    useEffect(() => {
        // Handle socket setup and room joining
        if (userInfo) {
            console.log("[SocketContext] User logged in, emitting setup for:", userInfo._id);
            socket.emit("setup", userInfo);
        } else {
            console.log("[SocketContext] No userInfo, skipping setup");
        }

        const handleConnect = () => {
            console.log("[SocketContext] Socket connected/reconnected: " + socket.id);
            if (userInfo) {
                console.log("[SocketContext] Connected, emitting setup for:", userInfo._id);
                socket.emit("setup", userInfo);
            }
        };

        socket.on("connect", handleConnect);

        return () => {
            socket.off("connect", handleConnect);
        };
    }, [userInfo]);

    return (
        <SocketContext.Provider value={{
            socket // Expose socket for chat features
        }}>
            {children}
        </SocketContext.Provider>
    );
};

export { ContextProvider, SocketContext };
